export default "__VITE_ASSET__CXaxTfWk__"